<template>
  <div></div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'step5',
  computed: {
    ...mapState({
      currentStep: state => state.steps.currentStep,
    }),
  },
};
</script>

<style scoped>

</style>
